import api from '../../../api';

// Get all roles
export const getRoles = async () => {
  try {
    const response = await api.get('/permissions/roles');
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

// Get all modules and capabilities
export const getModules = async () => {
  try {
    const response = await api.get('/permissions/modules');
    return response.data;
  } catch (error) {
    console.error('Error fetching modules:', error);
    // Fallback to mock for dev
    return [
      {
        name: 'Prospect',
        key: 'prospect',
        capabilities: [
          { key: 'view_own', label: 'View (Own)', description: 'View own prospects' },
          { key: 'view_global', label: 'View (Global)', description: 'View all prospects' },
          { key: 'create', label: 'Create', description: 'Create new prospects' },
          { key: 'edit', label: 'Edit', description: 'Edit prospects' },
          { key: 'delete', label: 'Delete', description: 'Delete prospects' },
          { key: 'export_data', label: 'Export Data', description: 'Export data' }
        ]
      },
      {
        name: 'Leads',
        key: 'leads',
        capabilities: [
          { key: 'view_own', label: 'View (Own)', description: 'View own leads' },
          { key: 'view_global', label: 'View (Global)', description: 'View all leads' },
          { key: 'create', label: 'Create', description: 'Create new leads' },
          { key: 'edit', label: 'Edit', description: 'Edit leads' },
          { key: 'delete', label: 'Delete', description: 'Delete leads' },
          { key: 'export_data', label: 'Export Data', description: 'Export data' }
        ]
      },
      {
        name: 'Proposal',
        key: 'proposal',
        capabilities: [
          { key: 'view_own', label: 'View (Own)', description: 'View own proposals' },
          { key: 'view_global', label: 'View (Global)', description: 'View all proposals' },
          { key: 'create', label: 'Create', description: 'Create new proposals' },
          { key: 'edit', label: 'Edit', description: 'Edit proposals' },
          { key: 'delete', label: 'Delete', description: 'Delete proposals' },
          { key: 'export_data', label: 'Export Data', description: 'Export data' }
        ]
      },
      {
        name: 'Payment',
        key: 'payment',
        capabilities: [
          { key: 'view_own', label: 'View (Own)', description: 'View own payments' },
          { key: 'view_global', label: 'View (Global)', description: 'View all payments' },
          { key: 'create', label: 'Create', description: 'Create new payments' },
          { key: 'edit', label: 'Edit', description: 'Edit payments' },
          { key: 'delete', label: 'Delete', description: 'Delete payments' },
          { key: 'export_data', label: 'Export Data', description: 'Export data' }
        ]
      }
    ];
  }
};

// Get permissions for a specific role
export const getRolePermissions = async (roleId) => {
  try {
    const response = await api.get(`/permissions/roles/${roleId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching role permissions:', error);
    throw error;
  }
};

// Update role permissions
export const updateRolePermissions = async (roleId, permissions) => {
  try {
    const response = await api.put(`/permissions/roles/${roleId}/permissions`, { permissions });
    return response.data;
  } catch (error) {
    console.error('Error updating role permissions:', error);
    throw error;
  }
};

// Initialize default permissions for a role
export const initializeRolePermissions = async (roleId) => {
  try {
    const response = await api.post(`/permissions/roles/${roleId}/initialize`);
    return response.data;
  } catch (error) {
    console.error('Error initializing role permissions:', error);
    throw error;
  }
}; 